import React, { useState, useEffect } from "react";
import ActionBar from "../../common/ActionBar";
import styled from "styled-components";
import { getMonth } from "../component/util";
import useCalendar from "../../../hooks/useCalender";
import CalendarHeader from "../component/CalendarHeader";
import Month from "../component/Month";
import CaseService from "../../../services/CaseService";

const Index = () => {
  const [currenMonth, setCurrentMonth] = useState(getMonth());
  const { setFilterEvents, monthIndex } = useCalendar();

  useEffect(() => {
    (async function dailyCauseList() {
      try {
        const response = await CaseService.dailyCauseList();
        if (response) {
          setFilterEvents(
            response.caseDet.map((item) => ({ ...item, color: "#00838c" })),
          );
        }
      } catch (error) {
        console.log(error);
      }
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCurrentMonth(getMonth(monthIndex));
  }, [monthIndex]);

  return (
    <PageWrapper>
      <ActionBar breadcrumbs={["Daily Cause list"]} />
      <MainContainer>
        <CalendarHeader />
        <CalendarContent>
          <Month month={currenMonth} />
        </CalendarContent>
      </MainContainer>
    </PageWrapper>
  );
};

export default Index;

const PageWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%);
`;

const MainContainer = styled.div`
  // height: calc(100vh - 80px);
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(
      180deg,
      rgba(41, 52, 97, 0.03) 0%,
      transparent 100%
    );
    pointer-events: none;
  }
`;

const CalendarContent = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;
